export default {
  "ddbe9fdda1937e8067ae26d31e758a69": "Confirm the order at the checkout counter",
  "f60e3d2b532a6909bcdd56086693c022": "Free course",
  "af4e086186dc7292e7fe6d5d4af8e070": "; Gift",
  "fe7ef76e50b4b8982b4986961a1e48be": "Coupon ID",
  "20afd873cfb7cf8e96c084e603feb32b": "; Voucher ID",
  "3d43a03f9649af819ca1cd07795d175d": "; Total price",
  "64a7c518c73dc80c929280695ef7f730": "This product is temporarily unavailable for purchase. Please contact customer service",
  "f274c45fe1f59f943b0635650644f18f": "No selected product",
  "e5221976fe0061c364b2af35d755b2bd": "No address selected",
  "1bc7355c38a9105d09bcc42e6beea46b": "No payment method was selected",
  "ac14a25586644305c664a0cfd0745924": "Alipay was not detected",
  "6d29c550cf3e1024a5bb939352a68a30": "Confirm order checkout counter - Click the \"Pay Now\" button",
  "11033d3cd42c64a797ba83c8e1d411c1": "\"Mall Order confirmation page - Bottom button.",
  "3c8e67cdffc4247838f712b776ff133e": "Click on the coupon on the mall order confirmation page",
  "3b8b66af6eacd73cd5646dbced53f092": "Has been taken off the shelves",
  "fbd0b805b279b854b092c73047e59a53": "Sold out",
  "c4bb227feaf34e0fb7111d181c92ee48": "Exchange now",
  "813068367ffc4a2607ad35d2907e96d3": "Sign the contract immediately",
  "f8b36b90160e00e89d9964d966acb108": "Sign a contract for free",
  "640cc04f9a9212f49be05074a04ccfa0": "\"Pay immediately",
  "920338af3975d212bed08b7e45cc8713": "Order placement page",
  "37111d7686ec1139e22178f585782461": "The subject expansion component has been exposed",
  "1dbe524f32b40d27c74c2426ee899732": "Parameter error!",
  "1be65297d44b755319cf6ea4a2b9659e": "Signing the contract...",
  "e5e6097c06fd5f5d3e87ae462adc8f23": "Payment in progress...",
  "2d962569f8d1c75433f8d9fa3d1fa5f6": "Product details",
  "fc47c520fb3452ac8dcd243e54a8f2e1": "Price details",
  "1d6f71e5c4c07373595e37b34ded4a11": "Payment method",
  "07710d908fd710218e2f38df3bc99d90": "Are you sure you want to give up paying?",
  "74e152f4159cf367bdbd756936b73a86": "The payment result is being confirmed",
  "9adb2a2ad039b13485a06ffd4ec9f229": "Please do not make duplicate payments or leave this page"
}
